export enum AiSuggestionWorkspaceItemType {
  action_item = 'AiSuggestion::WorkspaceItem::ActionItem',
  discussion_topic = 'AiSuggestion::WorkspaceItem::DiscussionTopic',
}

export type AiSuggestionWorkspaceItem = {
  body: string;
  citation: string;
  additionalInformation: string;
  slug: string;
  type: AiSuggestionWorkspaceItemType;
  message: {
    channelId: string;
    channelName: string;
    ts: string;
    threadTs: string;
    slackLink: string;
  };
};
